import React from "react";
import "./NotFound.scss";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="coming-soon">
      <h1>Coming Soon!</h1>
      <p>We're working hard to bring this page to you. Check back soon!</p>
      <Link to="/">Go Back Team</Link>
    </div>
  );
}
